var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-date-picker',_vm._g({staticClass:"CnDatePicker-font text-none font-weight-bold",attrs:{"show-adjacent-months":_vm.showAdjacentMonths,"color":_vm.datePickerColour,"value":_vm.getMaxDate,"max":_vm.getMaxDate,"isDob":""}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }